import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id E0A0FF12-A5AD-40E3-B286-8958154F0537
 * name checkbox-multiple-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-multiple-outline.svg
 * tags
 * - Form 
 */
export const CheckboxMultipleOutlineIcon = createSvgIcon(<><path d="M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H8V4H20V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M18.53,8.06L17.47,7L12.59,11.88L10.47,9.76L9.41,10.82L12.59,14L18.53,8.06Z" /></>, 'CheckboxMultipleOutlineIcon');
export default CheckboxMultipleOutlineIcon